// extracted by mini-css-extract-plugin
module.exports = {"container":"error-panel_container__2ZaJ2","icon":"error-panel_icon__jP6xS","text":"error-panel_text__2a__o"};